import APIService from '@/services/APIService.js'

export default {
  index() {
    return APIService.apiCall().get('/consultasModelos/getConsultasModelos');
  },
  getRelatorio(id) {
    return APIService.apiCall().get(`/consultasModelos/get/${id}`)
  },
  salvar(postData) {
    return APIService.apiCall().post(`/consultasModelos/salvar/${postData.id}`,JSON.stringify(postData))
  },
  deletar(id) {
    return APIService.apiCall().get(`/consultasModelos/excluir/${id}`)
  },
  getGruposRelatorios() {
    return APIService.apiCall().get('/gruposRelatorios/index')
  },
  getBasesDadosLiberadas() {
    return APIService.apiCall().get('/consultasModelos/getBasesDadosLiberadas')
  },
  getBasesDadosCampos(baseDados) {
    return APIService.apiCall().get(`/consultasModelos/getBasesDadosCampos/${baseDados}`)
  }
}